import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Usage from "../../Docs/Components/Persona/PersonaUsage.mdx";

import Examples from "../../Docs/Components/Persona/PersonaExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Persona"
            description="Persona renders icons representing people or groups."
            apiSources={["azure-devops-ui/Components/VssPersona/VssPersona.Props.d.ts"]}
            examples={Examples}
            internalLinks={{"figma":"https://www.figma.com/file/IL9e6Ol12kDojgd26oEgoy6m/Codex-Design-System-Deprecated?node-id=9624%3A449"}}
            status={{"design":"done","code":"done","docs":"Planned (Q3)"}}
            usage={Usage}
        />
    );
}
}
        
export default Page;